let MetricUtil = require("../util/MetricUtil");

let MetricBullet = function (props) {
  let {
    data,
    keyAvg,
    keyMin,
    keyMax,
    unit
  } = props;

  let units = {
    "HR": "bpm",
    "HRV": "",
    "HRV_RMSSD": "ms",
    "RESPIRATION": "br/min"
  };

  let out = (key) => {
    return mc.format.number(data[key], MetricUtil.precision(key));
  };

  return (
    <div className="rc-metric-bullet">
      <img src={"./img/rc/report." + unit + ".svg"} width="45" height="45"/>
      <span className="rc-metric-bullet-avg">
        <span data-tooltip={tx(keyAvg)}>
          {typeof data[keyAvg] === "number" ? (
            <span>
              {out(keyAvg)}
              <span className="rc-metric-bullet-unit">
                {units[unit]}
              </span>
            </span>
          ) : "N/A"}
        </span>
      </span>
      {keyMin && keyMax ? (
        <span>
          <span className="rc-metric-bullet-min" data-tooltip={tx(keyMin)}>
            {typeof data[keyMin] === "number" ? out(keyMin) : "N/A"}
          </span>
          <span className="rc-metric-bullet-max" data-tooltip={tx(keyMax)}>
            {typeof data[keyMax] === "number" ? out(keyMax) : "N/A"}
          </span>
        </span>
      ) : null}
    </div>
  );
};

module.exports = MetricBullet;